import * as Sentry from '@sentry/react'

import { useCallback, useEffect, useState } from 'react'

import zoomSDK from '@zoom/appssdk'

import { APIError } from '@/lib/asyncThunk'
import { actions } from '@/slices/auth'
import { useAppDispatch } from '@/store'
import configureZoom from '@/util/configure-zoom'

export default function useZoom() {
  const dispatch = useAppDispatch()
  const [error, setError] = useState<APIError<unknown>>()

  const handleZoomContext = useCallback(async () => {
    try {
      if (!window.isZoom) return

      await configureZoom()

      const { context } = await zoomSDK.getAppContext()

      const { context: ctx } = await zoomSDK.getRunningContext()
      if (ctx !== 'inMainClient') {
        console.log('[JOURNEY] not in main zoom client')
        return
      }

      const response = await fetch('/api/zoom/context', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
        body: JSON.stringify({ context }),
      })

      if (response.status >= 400 && response.status < 500) {
        const resp = (await response.json()) as APIError<unknown>
        setError(resp)
        return
      }

      const { token, role } = await response.json()
      dispatch(actions.setAuth({ token, role }))
    } catch (e) {
      Sentry.captureException(e)
      console.log('[JOURNEY] authentication error: ' + (e as Error).message)
      setError({
        error: (e as Error).message,
        statusCode: 0,
      })
    }
  }, [dispatch])

  useEffect(() => {
    handleZoomContext()
  }, [handleZoomContext])

  return [window.isZoom, error] as const
}
